import { jsx, jsxs } from "react/jsx-runtime";
import { useContainer, useEditor, usePeerIds, useValue } from "@tldraw/editor";
import { Popover as _Popover } from "radix-ui";
import { useTldrawUiComponents } from "../../context/components.mjs";
import { useCollaborationStatus } from "../../hooks/useCollaborationStatus.mjs";
import { useMenuIsOpen } from "../../hooks/useMenuIsOpen.mjs";
import { useDirection, useTranslation } from "../../hooks/useTranslation/useTranslation.mjs";
import { OfflineIndicator } from "../OfflineIndicator/OfflineIndicator.mjs";
import { DefaultPeopleMenuContent } from "./DefaultPeopleMenuContent.mjs";
function DefaultPeopleMenu({ children }) {
  const msg = useTranslation();
  const dir = useDirection();
  const container = useContainer();
  const editor = useEditor();
  const userIds = usePeerIds();
  const userColor = useValue("user", () => editor.user.getColor(), [editor]);
  const userName = useValue("user", () => editor.user.getName(), [editor]);
  const [isOpen, onOpenChange] = useMenuIsOpen("people menu");
  const collaborationStatus = useCollaborationStatus();
  const { PeopleMenuFacePile } = useTldrawUiComponents();
  if (collaborationStatus === "offline") {
    return /* @__PURE__ */ jsx(OfflineIndicator, {});
  }
  if (!userIds.length || !children && !PeopleMenuFacePile) {
    return null;
  }
  const content = children ?? /* @__PURE__ */ jsx(DefaultPeopleMenuContent, { userIds });
  return /* @__PURE__ */ jsxs(_Popover.Root, { onOpenChange, open: isOpen, children: [
    /* @__PURE__ */ jsx(_Popover.Trigger, { dir, asChild: true, children: /* @__PURE__ */ jsx("button", { className: "tlui-people-menu__avatars-button", title: msg("people-menu.title"), children: PeopleMenuFacePile ? /* @__PURE__ */ jsx(PeopleMenuFacePile, { userColor, userIds, userName }) : null }) }),
    /* @__PURE__ */ jsx(_Popover.Portal, { container, children: /* @__PURE__ */ jsx(
      _Popover.Content,
      {
        dir,
        className: "tlui-menu",
        side: "bottom",
        sideOffset: 2,
        collisionPadding: 4,
        children: /* @__PURE__ */ jsx("div", { className: "tlui-people-menu__wrapper", children: content })
      }
    ) })
  ] });
}
export {
  DefaultPeopleMenu
};
//# sourceMappingURL=DefaultPeopleMenu.mjs.map
